type State = {
  previewHighschoolId?: string | null
  selectedSchools: string[]
  isFilterDrawerOpen: boolean
  isViewChanging: boolean
  columnManagementOpen: boolean
}

type Action =
  | { type: 'filter-drawer-toggled'; isOpen: boolean }
  | { type: 'preview-highschool-change'; previewHighschoolId: string | null }
  | { type: 'selection-change'; selectedSchools: string[] }
  | { type: 'view-changing-toggled'; isChanging: boolean }
  | { type: 'column-management-toggled'; isOpen: boolean }

export default function highSchoolExploreReducer(state: State, action: Action): State {
  switch (action.type) {
    case 'preview-highschool-change':
      return { ...state, previewHighschoolId: action.previewHighschoolId }
    case 'filter-drawer-toggled':
      return {
        ...state,
        isFilterDrawerOpen: action.isOpen,
      }
    case 'selection-change':
      return {
        ...state,
        selectedSchools: action.selectedSchools,
      }
    case 'view-changing-toggled':
      return {
        ...state,
        isViewChanging: action.isChanging,
      }
    case 'column-management-toggled':
      return {
        ...state,
        columnManagementOpen: action.isOpen,
      }
  }
}
